import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactDirectory\GetMergeCandidatesController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetMergeCandidatesController.php
* @route '/api/contact-directory/merge/candidates'
*/
const GetMergeCandidatesController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMergeCandidatesController.url(options),
    method: 'get',
})

GetMergeCandidatesController.definition = {
    methods: ["get","head"],
    url: '/api/contact-directory/merge/candidates',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ContactDirectory\GetMergeCandidatesController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetMergeCandidatesController.php
* @route '/api/contact-directory/merge/candidates'
*/
GetMergeCandidatesController.url = (options?: RouteQueryOptions) => {
    return GetMergeCandidatesController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactDirectory\GetMergeCandidatesController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetMergeCandidatesController.php
* @route '/api/contact-directory/merge/candidates'
*/
GetMergeCandidatesController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMergeCandidatesController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactDirectory\GetMergeCandidatesController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetMergeCandidatesController.php
* @route '/api/contact-directory/merge/candidates'
*/
GetMergeCandidatesController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetMergeCandidatesController.url(options),
    method: 'head',
})

export default GetMergeCandidatesController